<template id="product-drilldown">
    <section>
        <div class="row">
            <div class="col-md-10 col-lg-12 text-center mt-3 mb-5">
                <div class="card">
                    <div class="card-header text-left">
                        Product Performance
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-bordered table-hover">
                                <thead class="thead-dark">
                                <tr>
                                    <th></th>
                                    <th>Product Category</th>
                                    <th>Transactions</th>
                                    <th>Sales Amount</th>
                                    <th>Margin</th>
                                    <th>Margin%</th>
                                    <th>Actions</th>
                                    <th>Assign</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="(p,idx) in productData">
                                    <tr v-bind:key="idx">
                                        <td><a @click="loadLevelOne(p.name)">+</a></td>
                                        <td>{{p.name}}</td>
                                        <td class="text-right">{{p.txns}}</td>
                                        <td class="text-right">{{p.txnamt}}</td>
                                        <td class="text-right">{{p.txnamt-p.cstamt}}</td>
                                        <td class="text-right">{{(((p.txnamt-p.cstamt)*100)/p.txnamt).toFixed(2)}}</td>
                                        <td>
                                            <a @click="commentBox('Retailer Drilldown', 'drilldown_report')">
                                                <i class="fa fa-tags text-primary"></i>
                                            </a>
                                            <a @click="assignModal('retailer_view', p.retailer_id)">
                                                <i class="fa fa-user-cog text-info"></i>
                                            </a>
                                        </td>
                                        <td>
                                            <span v-if="p.assign==null">- NA -</span>
                                            <span v-if="p.assign!=null">{{item.assign}}</span>
                                        </td>
                                    </tr>
                                    <tr v-if="whatL1 === p.name" class="table-info" v-bind:key="`p-${idx}`">
                                        <th></th>
                                        <th><span class="offset-md-1">Sub Category</span></th>
                                        <th>Transaction</th>
                                        <th>Sale Amount</th>
                                        <th>Margin</th>
                                        <th>Margin%</th>
                                        <th>Action</th>
                                        <th>Assign</th>
                                    </tr>
                                    <template v-for="(f1,idx) of l1Data">
                                        <tr v-bind:key="`f1-${idx}`" v-if="whatL1 === p.name">
                                            <td>
                                                <a href="#" @click="loadLevelTwo(f1.name, f1.brand)">
                                                    <span class="offset-md-1"> &gt;&gt;</span>
                                                </a>
                                            </td>
                                            <td><span class="offset-md-1">{{f1.brand}}</span>
                                            </td>
                                            <td class="text-right"><span
                                            >{{f1.txns}}</span></td>
                                            <td class="text-right"><span
                                                    v-b-tooltip.hover title="Sale Amount">{{f1.txnamt}}</span></td>
                                            <td class="text-right"><span>{{f1.txnamt-f1.cstamt}}</span>
                                            </td>
                                            <td class="text-right">
                                                <span>{{(((f1.txnamt-f1.cstamt)*100)/f1.txnamt).toFixed(2)}}</span>
                                            </td>
                                            <td>
                                                <a @click="commentBox('Retailer Drilldown', 'drilldown_report')">
                                                    <i class="fa fa-tags text-primary"></i>
                                                </a>
                                                <a @click="assignModal('retailer_view', p.retailer_id)">
                                                    <i class="fa fa-user-cog text-info"></i>
                                                </a>
                                            </td>
                                            <td v-b-tooltip.hover title="Assign">
                                                <span v-if="p.assign==null">- NA -</span>
                                                <span v-if="p.assign!=null">{{p.assign}}</span>
                                            </td>
                                        </tr>
                                        <tr v-if="whatL1 === p.name && whatL2 === f1.brand" class="table-primary"
                                            v-bind:key="`f2-${idx}`">
                                            <th></th>
                                            <th><span class="offset-md-2">SKU Name</span></th>
                                            <th>Transaction</th>
                                            <th>Sale Amount</th>
                                            <th>Margin</th>
                                            <th>Margin%</th>
                                            <th>Action</th>
                                            <th>Assign</th>
                                        </tr>
                                        <template v-for="(f2,idx) of l2Data">
                                            <tr class="f-s" v-bind:key="`f3-${idx}`"
                                                v-if="whatL1 === p.name && whatL2 === f1.brand">
                                                <td><span class="offset-md-3">&#8680;</span></td>
                                                <td><span class="offset-md-2">{{f2.productCategory}}</span></td>
                                                <td class="text-right">{{f2.txns}}</td>
                                                <td class="text-right">{{f2.txnamt}}</td>
                                                <td class="text-right">{{f2.txnamt-f2.cstamt}}</td>
                                                <td class="text-right">
                                                    {{(((f2.txnamt-f2.cstamt)*100)/f2.txnamt).toFixed(2)}}
                                                </td>
                                                <td>
                                                    <a @click="commentBox('Retailer Drilldown', 'drilldown_report')">
                                                        <i class="fa fa-tags text-primary"></i>
                                                    </a>
                                                    <a @click="assignModal('retailer_view', p.retailer_id)">
                                                        <i class="fa fa-user-cog text-info"></i>
                                                    </a>
                                                </td>
                                                <td>
                                                    <span v-if="p.assign==null">- NA -</span>
                                                    <span v-if="p.assign!=null">{{p.assign}}</span>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios'

export default {
    name: 'product-drilldown',
    data: function () {
      return {
        productData: [],
        whatL1: null,
        whatL2: null,
        l1Data: [],
        l2Data: []
      }
    },
    created: function () {
      this.loadProduct()
    },
    methods: {
      //Get Request
      loadProduct: function () {
        let url = '/api/product_view'
        axios.get(url)
          .then(res => {
            this.productData = res.data
          }, err => {
            console.log('Error in fetching data', err)
          })
      },

      //Get Request Level - 1 Data
      loadLevelOne: function (l1) {
        if (this.whatL1 === l1) {
          this.whatL1 = null
        } else {this.whatL1 = l1}
        let url = '/api/sub_category/' + l1
        axios.get(url)
          .then(res => {
            this.l1Data = res.data
          }, err => {
            console.log('Error in fetching l1 data', err)
          })
      },

      //Get Request Level - 2 Data
      loadLevelTwo: function (l1, l2) {
        if (this.whatL2 === l2) {
          this.whatL2 = null
        } else {this.whatL2 = l2}
        let url = '/api/sku/' + l1 + '/' + l2
        axios.get(url)
          .then(res => {
            this.l2Data = res.data
          }, err => {
            console.log('Error in fetching l2 data', err)
          })
      },
    }//Method Ends
  }
</script>
<style>
    .f-s {
        font-style: italic;
        font-weight: bold;
    }
</style>